import React, { useEffect, useState } from 'react';
import { AiFillCloseCircle, AiOutlinePlusSquare } from 'react-icons/ai';
import './leave-details.css';
import CloseIcon from '@mui/icons-material/Close';
import { TokenService } from '../../services/token.service';
import { getAllLeaveOfEmployee, downloadLeaveAttachment } from '../../api-services/employee-services';

interface LeaveDetailsProps {
    items: any;
    onClose: () => void
}
const LeaveDetails = (props: LeaveDetailsProps) => {
    const extractToken = TokenService.extractToken();
    const [leaveHistory, setLeaveHistory] = useState<any[]>([]);

    useEffect(() => {
        if (!props.items) return;
        getAllLeaveOfEmployee(extractToken?.sub).then((res: any) => {
            if (res?.data?.success) {
                const myLeaves = res.data.payload.filter((l: any) => 
                    l.leaveType?.toLowerCase().trim() === props.items.leaveType?.toLowerCase().trim() ||
                    l.leaveType?.toLowerCase().includes(props.items.leaveType?.toLowerCase().trim())
                );
                setLeaveHistory(myLeaves);
            }
        }).catch(() => {});
    }, [extractToken?.sub, props.items?.leaveType]);

    const onDownloadAttachment = (id: any, filename: string, name: string) => {
        const filesName = `${name}_${filename}`;
        downloadLeaveAttachment(id).then((response: any) => {
            if (response?.data) {
                const linkSource = window.URL.createObjectURL(response.data);
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = filesName;
                downloadLink.click();
            }
        });
    };

    if (!props.items) return null;

    return (
        <div className='main'>

            <div className='leave-details-sub-container'>

                <div className="modal-heading">
                    <h4>{`${props.items.leaveType}(${props.items.leaveBreaks.balance} Days)`}</h4>
                    <CloseIcon
                        className='modal-close-button'
                        onClick={props.onClose}
                    />

                </div>
                <div className='modal-body'>
                    <div className="container-100 leave-containers">
                        <label style={{ marginTop: '5px' }}>Type</label>
                        <div>{props.items.leaveType}</div>
                        <br />
                        <label className='leave-containers-label'>Balance</label>
                        <div className='leave-details-balance-container'>
                            <div className={props.items.leaveBreaks.balance !== 0 ? 'leave-balance-show-container' : 'leave-balance-show-container1'}>{`${props.items.leaveBreaks.balance} Days`}</div>
                        </div>
                        <div className="leave-details-break-main-container">
                            <div className='leave-details-break-sub-container'>
                                <div>
                                    <label className='leave-containers-label'>Earned</label>
                                    <div>{props.items.leaveBreaks.earned}</div>
                                </div>
                                <div className='leave-details-break-container'>
                                    <label className='leave-containers-label'>Entitled</label>
                                    <div>{props.items.leaveBreaks.entitled}</div>
                                </div>
                                <div className='leave-details-break-container'>
                                    <label>Applied</label>
                                    <div>{props.items.leaveBreaks.applied || 0}</div>
                                </div>
                            </div>
                            <div className='leave-details-break-sub-container'>
                                <div>
                                    <label>Carried Over</label>
                                    <div>{props.items.leaveBreaks.carriedOver || 0}</div>
                                </div>
                                <div className='leave-details-break-container'>
                                    <label>Taken</label>
                                    <div>{props.items.leaveBreaks.taken || 0}</div>
                                </div>
                                <div className='leave-details-break-container'>
                                    <label>Reject</label>
                                    <div>{props.items.leaveBreaks.reject || 0}</div>
                                </div>
                            </div>

                        </div>
                        <div className="leave-details-history-container" style={{ marginTop: '20px' }}>
                            <h5>History & Attachments</h5>
                            <div style={{ maxHeight: '200px', overflowY: 'auto', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
                                {leaveHistory.length > 0 ? (
                                    leaveHistory.map((leave: any, index: number) => {
                                        const parts = leave.attachment && leave.attachment !== 'NA' ? leave.attachment.split('_') : null;
                                        const filename = parts ? parts[parts.length - 1].trim() : null;

                                        return (
                                            <div key={index} style={{ marginBottom: '15px', padding: '10px', background: '#f9f9f9', borderRadius: '4px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                    <strong>Status: {leave.leaveStatus}</strong>
                                                    <span>{leave.fromDate.split('T')[0]} to {leave.toDate.split('T')[0]}</span>
                                                </div>
                                                <div style={{ fontSize: '14px', marginBottom: '5px', wordBreak: 'break-word' }}>
                                                    <strong>Reason: </strong>{leave.reasonForLeave || 'No reason provided'}
                                                </div>
                                                {filename && (
                                                    <div
                                                        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline', fontSize: '14px' }}
                                                        onClick={() => onDownloadAttachment(leave.leaveId, filename, leave.name)}
                                                    >
                                                        Download Attachment
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div style={{ padding: '10px', textAlign: 'center', color: '#666' }}>
                                        No recent history found for {props.items.leaveType}.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeaveDetails